import Caisse from '@/generated/classes/Caisse';
export default class CaisseExtend extends Caisse {
  constructor() {
    super();
  }
}
